import { useEffect } from "react";
import { inject, observer } from "mobx-react";

import { fn_insert_quick_addr } from "function/FnBodySetting";
import SettingDefaultAddressViewItem from "views/setting/sub/SettingDefaultAddressViewItem";
import SettingWrapper from "views/setting/components/wrappers/SettingWrapper";
import { SectionTitle } from "components/ui/SectionTitle";
import FormField from "components/ui/FormField";
import { Button } from "components/ui/Button";

interface QuickAddr {
  shopCd: string;
  seq: string;
  addr: string;
}

const SettingDefaultAddressView = ({ rootStore }: { rootStore: any }) => {
  const { settingStore } = rootStore;
  const quickAddr = settingStore.getQuickAddr as QuickAddr[] | [];

  useEffect(() => {
    settingStore.setSettingUseMenu("address");
    settingStore.setSettingView(false);
  }, [settingStore]);
  return (
    <SettingWrapper title="주소키워드 설정" rootStore={rootStore}>
      <div className="scroll">
        <div className="inner">
          <div className="wrap_address">
            <SectionTitle title="자주 쓰는 주소 키워드" subTitle="주소 검색 시에 사용되는 주소 키워드 설정" />
            <input type="text" id="quickAddr" className="hide" value="" readOnly={true} />
            <div className="bg-ui-box p-4 !items-start flex gap-2 relative h-28">
              <FormField direction="row" className="w-full">
                <FormField.Label className="text-gray-800 !font-bold">키워드 입력</FormField.Label>
                <FormField.Input
                  maxLength={16}
                  value={settingStore.getQuickAddrCurr}
                  className="w-full !h-10 !border-input-border"
                  onChange={event => settingStore.setQuickAddrCurr(event.target.value)}
                  onKeyDown={e => {
                    if (e.key === "Enter") fn_insert_quick_addr(rootStore);
                  }}
                />
                <Button
                  type="button"
                  fullWidth={false}
                  className="!w-24"
                  onClick={() => fn_insert_quick_addr(rootStore)}
                >
                  등록
                </Button>
              </FormField>
              <p className="absolute text-text-tertiary text-sm bottom-9 left-[104px]">
                * 이름이 긴 아파트/상가/건물명, 자주가는 배달 지역명 등<br />* 띄어쓰기 포함 최대 16자까지 입력 가능
              </p>
            </div>

            {quickAddr.length > 0 ? (
              <ul className="list_address">
                {quickAddr.map((obj: QuickAddr, index: number) => (
                  <SettingDefaultAddressViewItem key={"settingAddr" + index} rootStore={rootStore} obj={obj} />
                ))}
              </ul>
            ) : (
              <div className="list_none">
                <h5 className="tit">
                  <span>이렇게 등록해보세요</span>
                </h5>
                <p>
                  이름이 긴 아파트/상가/건물명, 자주가는 배달 지역명 등<br />
                  예) 푸르지오3차아파트, 씨엔드에이치빌딩, 테헤란로35길87, 여의나루역2번출구 등
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </SettingWrapper>
  );
};

export default inject("rootStore")(observer(SettingDefaultAddressView));
